<script>
import { h } from "vue";
// Render empty for empty slots
export default {
  name: "VEmpty",
  render() {
    return h("div", {});
  },
};
</script>
